import { type AnyRecord, asRecord } from './tolerant-read'
/**
 * If `base` lives under a kind-specific field (protobuf / StowedElement JSON), merge it to the top
 * so `getBaseGeometry` / path fields match `unwrapElementData` in multiplayer sync.
 */
export const STOWED_ELEMENT_FIELDS: Record<number, readonly string[]> = {
  1: ['rectangleElement', 'rectangle_element', 'RectangleElement'],
  2: [
    'irregularPolygonElement',
    'irregularPolygon',
    'irregular_polygon',
    'IrregularPolygonElement',
  ],
  5: ['pageNumberElement', 'page_number_element', 'PageNumberElement'],
  6: ['textOnPathElement', 'text_on_path_element', 'TextOnPathElement'],
  7: ['groupElement', 'group_element', 'GroupElement'],
  8: ['ovalElement', 'oval_element', 'OvalElement'],
  9: ['polylineElement', 'polyline_element', 'PolylineElement'],
  10: ['regularPolygonElement', 'regular_polygon_element', 'RegularPolygonElement'],
}

export function unwrapElementData(data: AnyRecord, kindId: number): AnyRecord {
  if (data.base || data.Base) return data

  const candidates = STOWED_ELEMENT_FIELDS[kindId]

  if (!candidates) return data

  for (const field of candidates) {
    const nested = asRecord((data as AnyRecord)[field])

    if (nested && (nested.base || nested.Base)) {
      return { ...data, ...nested }
    }
  }

  return data
}
